import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { db } from "services/firebase";

const getFunctions = () => firebase.app().functions("us-central1");

export async function submitTeacherAnnotation(payload) {
  const callable = getFunctions().httpsCallable("submitTeacherAnnotation");
  const result = await callable(payload);
  return result.data;
}

export async function getSessionAnnotationContext(sessionId) {
  const callable = getFunctions().httpsCallable("getSessionAnnotationContext");
  const result = await callable({ sessionId });
  return result.data;
}

export async function deduplicateAnnotations({ institutionId, tciId, promptId }) {
  const callable = getFunctions().httpsCallable("deduplicateAnnotations");
  const result = await callable({ institutionId, tciId, promptId });
  return result.data;
}

export async function generatePromptCandidate({
  consolidatedFeedbackId,
  annotationId,
  targetPromptId,
  targetScopeId,
  targetScope = "org",
}) {
  const callable = getFunctions().httpsCallable("generatePromptCandidate");
  const result = await callable({
    consolidatedFeedbackId,
    annotationId,
    targetPromptId,
    targetScope,
    targetScopeId,
  });
  return result.data;
}

/** Dedupe TCI annotations, then generate a prompt candidate (PROMPT 7 pipeline). */
export async function requestCandidateReview({
  annotationId,
  institutionId,
  tciId,
  targetPromptId,
  targetScopeId,
  targetScope = "org",
}) {
  if (tciId && institutionId) {
    const dedupe = await deduplicateAnnotations({
      institutionId,
      tciId,
      promptId: targetPromptId,
    });
    return generatePromptCandidate({
      consolidatedFeedbackId: dedupe.consolidatedFeedbackId,
      targetPromptId,
      targetScope,
      targetScopeId,
    });
  }

  return generatePromptCandidate({
    annotationId,
    targetPromptId,
    targetScope,
    targetScopeId,
  });
}

export async function approvePromptCandidate({ candidateId }) {
  const callable = getFunctions().httpsCallable("approvePromptCandidate");
  const result = await callable({ candidateId });
  return result.data;
}

export async function rejectPromptCandidate({ candidateId, reviewNotes }) {
  const callable = getFunctions().httpsCallable("rejectPromptCandidate");
  const result = await callable({ candidateId, reviewNotes });
  return result.data;
}

export async function returnCandidateToFdec({ candidateId, questions }) {
  const callable = getFunctions().httpsCallable("returnCandidateToFdec");
  const result = await callable({ candidateId, questions });
  return result.data;
}

/**
 * Returned candidates that need FDE-C follow-up for the given TCIs.
 */
export async function listReturnedCandidatesForTcis({ institutionId, tciIds = [] }) {
  if (!institutionId || !tciIds.length) return [];
  const snap = await db
    .collection("promptCandidates")
    .where("institutionId", "==", institutionId)
    .where("status", "==", "returned")
    .limit(50)
    .get();
  return snap.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter((row) => tciIds.includes(row.tciId));
}

export const SEVERITY_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

export const ANNOTATION_STATUS_LABELS = {
  pending: "Pending review",
  "in-progress": "In progress",
  submitted: "Submitted",
  consolidated: "Consolidated",
};
